import React from "react";

export default function MediaFilter({ activeTab, setActiveTab, total, categories = [] }) {

  const tabs = ["All", ...categories];

  return (

    <section className="media-filter">
      <div className="container">
        <div className="media-filter-top">
          <div className="media-tabs">
            {
              tabs.map((tab) => (
                <div key={tab} className={`${activeTab === tab ? "theme-btn" : "theme-btn media-white-btn"
                    }`} onClick={() => setActiveTab(tab)} >
                  <span>{tab}</span>
                </div>
              ))
            }
          </div>
          <p><strong>Viewing: </strong>{total} Articles</p>
        </div>
      </div>
    </section>

  );
}
